module.exports = __webpack_public_path__ + "fonts/iconfont.72b48eef.woff";